/* V2 purchase presentation. Native product and bundle controllers still own prices, plans and cart requests. */
(() => {
  const section = document.querySelector('.jive-pdp-v2');
  const host = section?.querySelector('jive-product-form');
  if (!host) return;
  const buybox = section.querySelector('#JiveV2Buybox');
  const sticky = section.querySelector('[data-v2-sticky]');
  const source = host.querySelector('[data-total-price]');
  const current = section.querySelector('[data-v2-current-price]');
  const reference = section.querySelector('[data-v2-reference-price]');
  const saving = section.querySelector('[data-v2-price-saving]');
  const stickySaving = section.querySelector('[data-v2-sticky-saving]');
  const scarcity = section.querySelector('[data-v2-scarcity]');
  const labels = JSON.parse(section.querySelector('[data-v2-labels]').textContent);
  const stock = JSON.parse(section.querySelector('[data-v2-stock-data]').textContent);
  const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll(`[${name}]`, replacement), labels[key] || '');
  const sync = () => {
    if (!host.dataset.enhanced || !Number.isFinite(host.total)) return;
    const lines = host.bundle ? host.bundle.selected() : host.variant ? [{ variant: host.variant, quantity: Math.max(1, Math.floor(Number(host.quantityInput.value) || 1)) }] : [];
    const regular = lines.reduce((total, line) => total + line.variant.price * line.quantity, 0);
    const count = lines.reduce((total, line) => total + line.quantity, 0);
    current.textContent = host.format(host.total);
    const hasSaving = count > 0 && regular > host.total;
    reference.hidden = !hasSaving;
    saving.hidden = !hasSaving;
    reference.textContent = host.format(regular);
    saving.textContent = hasSaving ? text('saving', { amount: host.format(regular - host.total) }) : '';
    if (stickySaving) {
      stickySaving.hidden = !hasSaving;
      stickySaving.textContent = hasSaving ? text('stickySaving', { amount: host.format(regular - host.total) }) : '';
    }
    const plans = host.data.plans.flatMap(group => group.selling_plans);
    const selectedPlan = plans.find(plan => String(plan.id) === host.planInput?.value);
    const planName = selectedPlan?.name?.trim() || '';
    const interval = planName.match(/(\d+)\s*(days?|weeks?|months?|years?)/i);
    const cadence = interval ? `every ${interval[1]} ${interval[2].toLowerCase()}` : planName.replace(/^deliver(?:y)?\s+/i, '').toLowerCase();
    const renewal = lines.reduce((total, line) => {
      const allocation = line.variant.selling_plan_allocations.find(entry => String(entry.selling_plan_id) === host.planInput?.value);
      return total + (allocation?.price_adjustments?.at(-1)?.price ?? allocation?.price ?? line.variant.price) * line.quantity;
    }, 0);
    const subscriptionTotal = host.bundle ? host.bundle.prices(count, true, lines).total : Math.max(0, lines.reduce((total, line) => {
      const allocation = line.variant.selling_plan_allocations.find(entry => String(entry.selling_plan_id) === host.planInput?.value);
      return total + (allocation?.price ?? line.variant.price) * line.quantity;
    }, 0) - (host.offerEligible ? (host.data.firstOrderDiscount || 0) * (host.data.firstOrderDiscountEach ? count : 1) : 0));
    const renewalPercent = regular > 0 ? Math.round((1 - renewal / regular) * 100) : 0;
    const setCopy = (selector, copy) => section.querySelector(selector)?.replaceChildren(document.createTextNode(copy));
    const bonuses = section.querySelector('[data-v2-bonuses]');
    if (bonuses) {
      // Preview the same first-order offer that the native cart controller applies.
      const offerAllocation = host.variant?.selling_plan_allocations.find(allocation => String(allocation.selling_plan_id) === String(host.data.offerPlan));
      const offerPrice = offerAllocation ? Math.max(0, offerAllocation.price - (host.data.firstOrderDiscount || 0)) : 0;
      const offerPercent = offerAllocation && host.variant.price > 0 ? Math.round((1 - offerPrice / host.variant.price) * 100) : 0;
      const configured = !!offerAllocation && !!host.data.subscriptionGift && !!host.data.subscriptionCodes?.trim() && offerPercent > 0;
      bonuses.hidden = !configured;
      const unlocked = configured && host.subscription && host.offerEligible && !!host.variant?.available;
      bonuses.dataset.locked = String(!unlocked);
      setCopy('[data-v2-bonus-saving]', `${offerPercent}% off`);
      setCopy('[data-v2-bonus-status]', unlocked ? 'Your 3 bonuses are unlocked' : 'Subscribe to unlock 3 bonuses');
    }
    // The compact approximate unit price rounds the actual offer to the nearest 10 cents.
    const servingPrice = count ? Math.round(subscriptionTotal / (count * 30) / 10) * 10 : 0;
    const servingLabel = servingPrice < 100 ? `${servingPrice}¢` : host.format(servingPrice);
    setCopy('[data-v2-first-saving]', count ? `About ${servingLabel} per serving` : 'One serving, every day');
    const terms = section.querySelector('[data-recurring-terms]');
    terms.hidden = !host.subscription || !selectedPlan || !count;
    if (!terms.hidden) {
      const facts = [`Renews ${cadence}`, renewalPercent > 0 ? `Next order ${renewalPercent}% off` : '', 'Pause, skip, cancel anytime'];
      terms.replaceChildren(...facts.filter(Boolean).map(copy => {
        const fact = document.createElement('span');
        fact.textContent = copy;
        return fact;
      }));
    }
    if (!host.busy && !host.submitButton.disabled) setCopy('[data-add-label]', host.data.labels.add);
    if (host.bundle) {
      const nextBag = section.querySelector('[data-v2-next-bag]');
      const addButton = section.querySelector('[data-v2-add-bag]');
      const candidate = lines.find(line => line.variant.options[0] === host.bundle.lastFlavor)?.variant || lines[0]?.variant || host.variant;
      if (nextBag && candidate?.available) {
        nextBag.hidden = false;
        addButton.hidden = count >= 4;
        addButton.disabled = !!host.busy;
        addButton.dataset.flavor = candidate.options[0];
        addButton.setAttribute('aria-label', `Add another bag of ${candidate.options[0]}`);
        if (count >= 4) {
          setCopy('[data-v2-next-title]', 'Your best bundle saving is unlocked.');
          setCopy('[data-v2-next-detail]', `You save ${host.format(regular - host.total)} on this ${host.subscription ? 'first delivery' : 'order'}.`);
        } else {
          const nextLines = lines.map(line => ({ ...line }));
          const existing = nextLines.find(line => line.variant.id === candidate.id);
          if (existing) existing.quantity += 1; else nextLines.push({ variant: candidate, quantity: 1 });
          const nextPrice = host.bundle.prices(count + 1, host.subscription, nextLines);
          const percent = Math.round((1 - nextPrice.total / nextPrice.original) * 100);
          setCopy('[data-v2-next-title]', count ? `Add 1 bag. Save ${percent}%.` : 'Pick your first flavor.');
          setCopy('[data-v2-next-detail]', count ? `${host.format(nextPrice.total / (count + 1))} per bag ${host.subscription ? 'on your first delivery' : 'when you bundle'}. Mix any flavors.` : 'Your savings grow with every bag.');
        }
      }
    }
    const shipping = section.querySelector('[data-v2-shipping]');
    if (shipping) shipping.hidden = !count || !lines.every(line => line.variant.available && (!stock[line.variant.id]?.managed || stock[line.variant.id].quantity > 0));

    const limited = lines.find(line => {
      const record = stock[line.variant.id];
      return line.variant.available && record?.managed && record.policy === 'deny' && record.quantity > 0 && record.quantity <= 10;
    });
    scarcity.hidden = !limited;
    scarcity.textContent = limited ? text('limited', { count: stock[limited.variant.id].quantity, variant: stock[limited.variant.id].title }) : '';
  };
  const shipEta = section.querySelector('[data-v2-ship-eta]');
  const shippingDate = shipEta ? new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', weekday: 'short', hour: 'numeric', hourCycle: 'h23' }) : null;
  const updateShipping = () => {
    if (!shipEta) return;
    // Published policy: 2 PM Central cutoff, with dispatch on business days.
    const parts = shippingDate.formatToParts(new Date());
    const weekday = parts.find(part => part.type === 'weekday').value;
    const hour = Number(parts.find(part => part.type === 'hour').value);
    if (weekday === 'Sat' || weekday === 'Sun' || (weekday === 'Fri' && hour >= 14)) {
      shipEta.textContent = 'Ships next business day';
      return;
    }
    shipEta.textContent = hour < 14 ? 'Ships today' : 'Ships tomorrow';
  };
  section.querySelector('[data-v2-add-bag]')?.addEventListener('click', event => {
    const button = event.currentTarget;
    const flavor = button.dataset.flavor;
    const original = host.bundle?.querySelector(`[data-bundle-flavor="${CSS.escape(flavor)}"] [data-bundle-change="1"]`);
    if (original && !original.disabled) original.click();
  });
  // Only show the sticky after the purchase button has passed above the viewport.
  // Cache its document position so even instant scroll jumps need no layout read.
  let stickyBottom = Infinity;
  const setSticky = () => {
    const hidden = !host.dataset.enhanced || scrollY <= stickyBottom;
    if (sticky.hidden !== hidden) sticky.hidden = hidden;
  };
  const measureSticky = rect => {
    stickyBottom = scrollY + rect.bottom;
    setSticky();
  };
  const stickyObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    measureSticky(entries[0].boundingClientRect);
  }, { threshold: [0, 1] }) : null;
  let stickyFrame = 0;
  const updateSticky = () => {
    if (stickyFrame || !host.dataset.enhanced) return;
    stickyFrame = requestAnimationFrame(() => {
      stickyFrame = 0;
      measureSticky(host.submitButton.getBoundingClientRect());
    });
  };
  const observer = new MutationObserver(() => { sync(); updateSticky(); });
  observer.observe(source, { childList: true, characterData: true, subtree: true });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-v2-buybox-scroll]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    buybox.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    // Keep selected flavors, quantity, cadence, and purchase type unchanged.
    buybox.focus({ preventScroll: true });
  });
  window.addEventListener('scroll', stickyObserver ? setSticky : updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  const stickyLayout = typeof ResizeObserver === 'function' ? new ResizeObserver(updateSticky) : null;
  updateShipping();
  const shippingInterval = setInterval(() => { if (!section.isConnected) clearInterval(shippingInterval); else updateShipping(); }, 30000);
  customElements.whenDefined('jive-product-form').then(() => {
    sync();
    if (stickyObserver && host.submitButton) stickyObserver.observe(host.submitButton);
    stickyLayout?.observe(host);
    stickyLayout?.observe(document.body);
    updateSticky();
  });
})();
